import { Tooltip, TooltipIcon, TooltipMessage } from "@sainsburys-tech/luna-labs";
import React, { useState, useEffect, FC } from "react";
import { onKeyPress } from "@sainsburys-tech/luna-utils";
import { missingFamilyGroup } from "../../helpers/missingFamilyGroupHelper";
const TooltipComp = (props: any) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <>
      <div className="ln-u-display-flex@sm ln-u-align-items-center ln-u-margin-bottom*1/2 ldm-tooltip">
        <Tooltip
          open={isOpen}
          tooltipId="tooltip-4"
          position={props.position}
          priority={["top", "right", "bottom", "left"]}
          popper={{
            modifiers: {
              flip: {
                enabled: true,
                behaviour: "clockwise",
              },
            },
          }}
        >
          {props.value && (
            <span className={props.labelClass}>{props.value}</span>
          )}

          <TooltipIcon
            className={props.tooltipClass}
            onClick={(event: any) => {
              event.preventDefault();
              setIsOpen(!isOpen);
            }}
            onBlur={(event: any) => {
              setIsOpen(false);
            }}
            onKeyDown={onKeyPress([{ name: "Escape", code: 27 }], () =>
              setIsOpen(false)
            )}
          />
          <TooltipMessage className={props.messageClass}>
            {props.tooltip}
          </TooltipMessage>
        </Tooltip>
      </div>
    </>
  );
};

export default TooltipComp;
